import React from 'react';
import { Cpu, Lock } from 'lucide-react';
import KPICard from '../../components/shared/KPICard';
import StatusPill from '../../components/shared/StatusPill';
import SectionDivider from '../../components/shared/SectionDivider';
import { commandLogs } from '../../data/mockData';
import { formatDateTime } from '../../utils/dateHelpers';

export default function DiscomRemoteControl() {
  return (
    <div className="p-6 space-y-6">
      <div className="flex gap-4">
        <KPICard title="Remote Commands Today" value="4" subtext="2 success, 1 failed, 1 pending" />
        <KPICard title="Eligible Plants" value="2,840" subtext="PGVCL — SCADA-enabled" />
        <KPICard title="Avg Response Time" value="2.4s" subtext="Command acknowledgement" subtextColor="green" />
      </div>

      {/* Future phase tiles */}
      <div className="flex gap-4">
        <div className="flex-1 bg-white rounded-card border-2 border-dashed border-purple shadow-card p-6 flex flex-col items-center text-center">
          <div className="w-12 h-12 rounded-full bg-purple/10 flex items-center justify-center mb-3">
            <Cpu size={20} className="text-purple" />
          </div>
          <StatusPill status="future" label="Future Phase" dashed />
          <h3 className="text-sm font-semibold text-text-primary mt-2">Voltage Setpoint Control</h3>
          <p className="text-xs text-text-secondary mt-1">Adjust inverter voltage setpoints remotely per SLDC directive.</p>
          <div className="mt-4 bg-bg-secondary rounded-input p-3 w-full text-left">
            <p className="text-xs text-text-tertiary">Target voltage</p>
            <div className="flex items-center gap-2 mt-1">
              <input type="range" min={230} max={250} defaultValue={242} className="flex-1 opacity-40 cursor-not-allowed" disabled />
              <span className="text-sm font-bold text-text-primary">242 V</span>
            </div>
          </div>
          <div className="mt-2 flex items-center gap-1 text-xs text-text-tertiary">
            <Lock size={10} /> Available in SMART™ v2.0
          </div>
        </div>

        <div className="flex-1 bg-white rounded-card border-2 border-dashed border-purple shadow-card p-6 flex flex-col items-center text-center">
          <div className="w-12 h-12 rounded-full bg-purple/10 flex items-center justify-center mb-3">
            <Cpu size={20} className="text-purple" />
          </div>
          <StatusPill status="future" label="Future Phase" dashed />
          <h3 className="text-sm font-semibold text-text-primary mt-2">Reactive Power Setpoint</h3>
          <p className="text-xs text-text-secondary mt-1">Control reactive power injection/absorption for grid stability.</p>
          <div className="mt-4 bg-bg-secondary rounded-input p-3 w-full text-left">
            <p className="text-xs text-text-tertiary">Reactive power target</p>
            <div className="flex items-center gap-2 mt-1">
              <input type="range" min={0} max={2} step={0.1} defaultValue={0.8} className="flex-1 opacity-40 cursor-not-allowed" disabled />
              <span className="text-sm font-bold text-text-primary">0.8 kVAr</span>
            </div>
          </div>
          <div className="mt-2 flex items-center gap-1 text-xs text-text-tertiary">
            <Lock size={10} /> Available in SMART™ v2.0
          </div>
        </div>
      </div>

      {/* Command audit log */}
      <div className="bg-white rounded-card border border-border shadow-card p-4">
        <SectionDivider title="Command Audit Log" subtitle="Last 4 remote commands issued" />
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-2.5 text-text-tertiary font-medium">Timestamp</th>
              <th className="text-left py-2.5 text-text-tertiary font-medium">Command</th>
              <th className="text-left py-2.5 text-text-tertiary font-medium">Issued By</th>
              <th className="text-left py-2.5 text-text-tertiary font-medium">Target</th>
              <th className="text-center py-2.5 text-text-tertiary font-medium">Result</th>
            </tr>
          </thead>
          <tbody>
            {commandLogs.map((log, i) => (
              <tr key={i} className="border-b border-border/50 hover:bg-bg-secondary cursor-pointer">
                <td className="py-2.5 text-text-secondary whitespace-nowrap">{formatDateTime(log.timestamp)}</td>
                <td className="py-2.5 font-medium text-text-primary">{log.command}</td>
                <td className="py-2.5 text-text-secondary">{log.issuedBy}</td>
                <td className="py-2.5 font-mono text-text-secondary">{log.plantId}</td>
                <td className="py-2.5 text-center">
                  <StatusPill
                    status={log.result === 'SUCCESS' ? 'online' : log.result === 'FAILED' ? 'offline' : 'in_progress'}
                    label={log.result}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
